import { type Infer, array, number } from 'superstruct'

export const LastRoomsType = array(number())

export type LastRooms = Infer<typeof LastRoomsType>
